import React from 'react'

export const DoomScrolling = () => {
  return (
      <div className='recruiting-email'>
        <div className="recruiting-email__title">Subject: Doom Scrolling</div>
        <div className="recruiting-email__body">
          <p>
            <span className="redact">Hi William,</span>
          </p>
          <p>
            William <span className="redact">- Following</span> up <span className="redact">here on the opportunity at Freckle. Boasting a</span> 198% <span className="redact">retention rate (well above the industry gold standard), wanted to share their wall of love, yes, keep </span>scrolling!!
          </p>
          <p>
            Would love <span className="redact">to share</span> more <span className="redact">about what they’re building - they are a high</span> agency <span className="redact">team and</span> this <span className="redact">role</span> will have a large impact <span className="redact">with a direct line</span> to <span className="redact">customers.</span>
          </p>
          <p>
            <span className="redact">Hybrid in SF 3 days/week. </span>
          </p>
          <p>
            <span className="redact">Here's a link to</span> my <span className="redact">calendar again- excited to chat about this and any</span> other <span className="redact">late stage companies we're working with at the</span> moment.
          </p>
          <p>
            <span className="redact">Best,</span>
          </p>
          <p>
            <span className="redact">Redacted Name For Privacy</span>
          </p>
        </div>
      </div>
  )
}

export default DoomScrolling

{/* <div className='recruiting-email'>
        <div className="recruiting-email__title">Subject: Doom Scrolling</div>
        <div className="recruiting-email__body">
          <p>
            <span className="redact">Hi William,</span>
          </p>
          <p>
            <span className="redact">Hi William - I’m <span className="redact">working with</span> a <span className="redact">Gradient (Google’s</span> AI <span className="redact">Fund) backed </span>startup, <span className="redact">Freckle - they are already<span className="redact"> seeing massive adoption as the next Clay-alternative for GTM teams. The Freckle team has been focused on building extremely powerful research agents all via natural language inputs and looking for founding engineers to scale their vision.  
          </p>
        </div>
      </div> */}
